import React, { useEffect, useState } from 'react'
import { CardText, Col, Row, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPImage from 'framework/components/DPImage'
import DBFileBrowser from 'framework/components/DBFileBrowser'
import DPDropDown from 'framework/components/DPDropDown'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import { Link } from "react-router-dom"
//Social Media Imports
// import TwitterLogin from "react-twitter-auth"
//import { facebook, google } from "../../config"
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import { googleProvider, facebookProvider, msProvider, appleProvider, yahooProvider, twitterProvider } from '../../../FirebaseConstants';

import DPPasswordReset from 'framework/components/DPPasswordReset'
import DPImagePop from 'framework/components/DPImagePop'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"


const UserMasterTab1 = ({
    disabled,
    codeValue,
    CodeOnChange,
    CodeOnblur,
    fnameValue,
    fnameOnChange,
    lnameValue,
    lnameOnChange,
    nameValue,
    nameOnChange,
    passwordValue,
    passwordOnChange,

    barcodeValue,
    barcodeOnChange,
    groupValue,
    groupOnChange,
    nicValue,
    nicOnChange,
    genderValue,
    genderOnChange,
    filevalue,
    imagesrc,
    ShowPreview,
    dobValue,
    dobOnChange,
    jobValue,
    jobOnChange,
    discountValue,
    discountOnChange,
    signoffValue,
    signoffOnChange,
    activeValue,
    activeOnChange,
    modelTrigger,
    modelOpen,
    GetSelectRow,
    disableCode,
    DOBstate,
    nicOnBlur,
    dicountOnblur,
    FnameOnBlur,
    LnameOnBlur,
    cpasswordValue,
    cpasswordOnChange,
    currentPasswordValue,
    currentPasswordOnChange,
    EnablePass,

    responseOnSuccess,

    passdisabled,
    menuName,
    appUserOnChange,
    appUserValue,
    CheckUser,
    AddNew,
    Code,
    Name,
    confirmPassword,
    newPassword,
    SetConfirmPassword,
    SetNewPassword,
    OnAccept,
    OnSSOReset,
    reason,
    SetReason,
    logAlert,
    SetLogAlert,
    ErrorMsg,
    AlertMsg,
    AlertColor,
    show,
    SignINUserType,
    CheckAdmin,
    onButtonClick,
    btnDisable,
    menuCode,
    RemoveImage,
    GetPasswordBarcode,
    employee,
    setEmployee
}) => {

    const [jobDesig, SetJobDesig] = useState([])
    const [userGroup, SetuserGroup] = useState([])

    const [isOpen, SetIsOpen] = useState(false)


    const [HeadColumns, setHeadColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")
    const ApiURL = window.Links.ApiURL


    useEffect(async () => {
        setHeadColumns(await loadPopupSearchPay(menuCode, 'USER'))
    }, [menuCode]);


    const showPop = () => {
        SetIsOpen(!isOpen)
    }



    useEffect(() => {

        //********Get job designation dropdown data */
        function getJobDesignation() {
            const authToken = localStorage.getItem("authToken")
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            const ApiURL = window.Links.ApiURL
            fetch(`${ApiURL}Designation/Select/`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    SetJobDesig(result.data)
                    let dt = result.data

                }).catch(error => console.log('error', error));
        }
        //********End Get job designation dropdown data */


        //********Get job designation dropdown data */
        function getUserGroup() {
            const authToken = localStorage.getItem("authToken")
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            const ApiURL = window.Links.ApiURL
            fetch(`${ApiURL}UserGroup/Select/`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    SetuserGroup(result.data)
                    let dt = result.data

                }).catch(error => console.log('error', error));
        }
        //********End Get job designation dropdown data */

        getUserGroup()
        getJobDesignation()

    }, [])



    async function tog_backdrop() {
        modelTrigger();
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    const genderTable = [{ label: "Male", value: "M" }, { label: "Female", value: "F" }, { label: "Unassign", value: "U" }]

    //function SingleSignOn
    const singleSignON = (provider) => {
        const auth = getAuth();
        signInWithPopup(auth, provider)
            .then((result) => {
                console.log("result", result);
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                console.log("credential", credential);
                const token = credential.accessToken;
                // The signed-in user info.
                const user = result.user;
                // ...

                signInWithCredential(auth, credential)
                    .then((det) => {
                        console.log("det", det);
                        console.log(det)
                        responseOnSuccess(det.user.uid, det.providerId, det.user.email)
                    }).catch((er) => {
                        console.log("er", er);
                    });
            }).catch((error) => {
                console.log("error", error);
                // Handle Errors here.
                //const errorCode = error.code;
                //const errorMessage = error.message;
                // The email of the user's account used.
                //const email = error.customData.email;
                // The AuthCredential type that was used.
                //const credential = GoogleAuthProvider.credentialFromError(error);
                // ...
            });

        /* firebaseAuth().signInWithPopup(provider)
            .then(result => {
                firebaseAuth().signInWithCredential(result.credential)
                    .then((det) => {
                        console.log(det)
                        responseOnSuccess(det.user.uid, det.additionalUserInfo.providerId, det.user.email)
                    }).catch((er) => {
                        console.log(er);
                    });
            }).catch((err) => {
                console.log(err);
            }); */
    }


    return (
        <React.Fragment>
            <div>
                <Row>
                    <DPPasswordReset
                        confirm_both={logAlert}
                        onCancel={
                            () => SetLogAlert(false)
                        }
                        code={Code}
                        name={Name}
                        newPassword={newPassword}
                        confirmPassword={confirmPassword}
                        newPasswordOnchange={(e) => SetNewPassword(e.target.value)}
                        confirmPasswordOnChange={(e) => SetConfirmPassword(e.target.value)}
                        accept={OnAccept}
                        onReset={OnSSOReset}
                        btnColor="success"
                        cancelColor="danger"
                        resetColor="primary"
                        reason={reason}
                        reasonOnChange={(e) => SetReason(e.target.value)}
                        show={show}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        ErrorMsg={ErrorMsg}
                    />
                    <Col sm="12">
                        <CardText className="mb-4-sm">
                            <Row>
                                <Col sm={12} md={6} className="mb-4-sm">
                                    <Row>
                                        <Col sm={12} md={11} className="mb-4-sm">
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBoxButton
                                                        rowClass="mb-4-sm"
                                                        labelText="User Code *"
                                                        textType="text"
                                                        maxLength="30"
                                                        value={codeValue}
                                                        onChange={CodeOnChange}
                                                        onBlur={CodeOnblur}
                                                        disabled={disableCode}
                                                        onButtonClick={onButtonClick}
                                                        btnDisable={btnDisable}
                                                    />
                                                </Col>
                                                <Col sm={12} md={1} className="mb-4-sm">
                                                    <Button
                                                        color="success"
                                                        className="btn-sm"
                                                        size='sm'
                                                        onClick={e => {
                                                            tog_backdrop()
                                                        }}
                                                        disabled={disableCode}
                                                        style={{ width: 'auto' }}
                                                    >
                                                        <i
                                                            className="mdi mdi-search-web"
                                                            style={{ fontSize: "12px" }}
                                                        ></i>
                                                    </Button>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="First Name *"
                                                        textType="text"
                                                        maxLength="50"
                                                        value={fnameValue}
                                                        onBlur={FnameOnBlur}
                                                        onChange={fnameOnChange}
                                                        disabled={disabled} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Last Name"
                                                        textType="text"
                                                        maxLength="50"
                                                        value={lnameValue}
                                                        onBlur={LnameOnBlur}
                                                        onChange={lnameOnChange}
                                                        disabled={disabled} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Full Name"
                                                        textType="text"
                                                        maxLength="50"
                                                        value={nameValue}
                                                        onChange={nameOnChange}
                                                        disabled={disabled} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    {EnablePass ? <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Current Password"
                                                        textType="password"
                                                        maxLength="20"
                                                        value={currentPasswordValue}
                                                        onChange={currentPasswordOnChange}
                                                        disabled={disabled} /> : null}
                                                </Col>
                                            </Row>
                                            <Row></Row>

                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col sm={12} md={11} className="mb-4-sm">

                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Password"
                                                        textType="password"
                                                        maxLength="20"
                                                        value={passwordValue}
                                                        onChange={passwordOnChange}
                                                        disabled={disabled == true ? true : passdisabled} />
                                                </Col>
                                                <Col sm={12} md={1} className="mb-4-sm">
                                                    {SignINUserType == "ADM" && AddNew == false ? <Col sm={1} md={1} className="mb-4-sm">
                                                        <Button
                                                            color="danger"
                                                            className="btn-sm"
                                                            onClick={e => {
                                                                SetLogAlert(true)
                                                                SetNewPassword("")
                                                                SetConfirmPassword("")
                                                                SetReason("")
                                                            }}
                                                            disabled={disabled}
                                                        >
                                                            <i
                                                                className="mdi mdi-lock-reset"
                                                                style={{ fontSize: "12px" }}
                                                            ></i>
                                                        </Button>
                                                    </Col> : null}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Confirm Password"
                                                        textType="password"
                                                        maxLength="20"
                                                        value={cpasswordValue}
                                                        onChange={cpasswordOnChange}
                                                        disabled={disabled == true ? true : passdisabled}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Password barcode *"
                                                        textType="password"
                                                        maxLength="20"
                                                        value={barcodeValue}
                                                        onChange={barcodeOnChange}
                                                        disabled={disabled}
                                                        showHiddenPassword={true}
                                                    />
                                                </Col>
                                                <Col sm={12} md={1} className="mb-4-sm">
                                                    <Button
                                                        color="success"
                                                        className="btn-sm"
                                                        size='sm'
                                                        onClick={e => {
                                                            GetPasswordBarcode()
                                                        }}
                                                        disabled={disableCode == true ? true : AddNew == true ? false : true}
                                                        style={{ width: 'auto' }}
                                                    >
                                                        <i
                                                            className="mdi mdi-note-text-outline"
                                                            style={{ fontSize: "12px" }}
                                                        ></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPDropDown
                                                        rowClass="mb-4-sm"
                                                        labelText="Group Code *"
                                                        textType="text"
                                                        selectedGroup={groupValue}
                                                        optionGroup={userGroup}
                                                        onChange={groupOnChange}
                                                        disabled={disabled == true ? disabled : CheckAdmin} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="NIC Number"
                                                        textType="text"
                                                        maxLength="10"
                                                        value={nicValue}
                                                        onChange={nicOnChange}
                                                        onBlur={nicOnBlur}
                                                        disabled={disabled} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPDropDown
                                                        rowClass="mb-4-sm"
                                                        labelText="Gender"
                                                        textType="text"
                                                        selectedGroup={genderValue}
                                                        optionGroup={genderTable}
                                                        onChange={genderOnChange}
                                                        disabled={disabled == true ? disabled : DOBstate} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Date of Birth"
                                                        textType="date"
                                                        value={dobValue}
                                                        onChange={dobOnChange}
                                                        disabled={disabled == true ? disabled : DOBstate}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={11} className="mb-4-sm">
                                                    <DPTextBox
                                                        rowClass="mb-4-sm"
                                                        labelText="Employee #"
                                                        textType="text"
                                                        value={employee}
                                                        onChange={setEmployee}
                                                        disabled={disabled}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>
                                </Col>
                                <Col sm={12} md={6} className="mb-4-sm">
                                    <Row>
                                        <Col sm={12} md={12} className="mb-4-sm">
                                            <div>
                                                <Row>
                                                    <Col sm="12">
                                                        <CardText className="mb-0">
                                                            <Row>
                                                                <Col sm={12} md={12} className="mb-4-sm">
                                                                    <DPImage
                                                                        labelText={imagesrc}
                                                                        onClick={showPop}
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></DPImage>
                                                                    <DPImagePop
                                                                        toggle={showPop}
                                                                        isOpen={isOpen}
                                                                        width={'400px'}
                                                                        height={'400px'}
                                                                        ImgSrc={imagesrc}
                                                                    />
                                                                    <DBFileBrowser
                                                                        accept="image/*"
                                                                        rowClass="mb-4-sm"
                                                                        showPrewiew={ShowPreview}
                                                                        disable={disabled}
                                                                        value={filevalue}
                                                                    ></DBFileBrowser>

                                                                </Col>
                                                            </Row>
                                                        </CardText>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} md={3} className="mb-4-sm">
                                            <Button
                                                color="danger"
                                                className="mr-1 mt-1"
                                                disabled={disabled}
                                                onClick={RemoveImage}
                                                size="sm"
                                            >
                                                Remove Image
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Col sm={12} md={12} className="mb-4-sm">
                                        <DPDropDown
                                            rowClass="mb-4-sm"
                                            labelText="Job Designation"
                                            textType="text"
                                            selectedGroup={jobValue}
                                            optionGroup={jobDesig}
                                            onChange={jobOnChange}
                                            disabled={disabled == true ? disabled : CheckAdmin}
                                        />
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Max Discount"
                                            textType="text"
                                            textAlign="right"
                                            value={discountValue}
                                            onChange={discountOnChange}
                                            onBlur={dicountOnblur}
                                            disabled={disabled == true ? disabled : CheckAdmin} />
                                        <Row>
                                            <Col sm={3}>
                                                <Label
                                                    htmlFor="example-text-input"
                                                    className={`col-md-12 col-form-label-sm`}
                                                >
                                                    Active *
                                                </Label>
                                            </Col>
                                            <Col >
                                                <DPSwitch
                                                    rowClass={"mb-4-sm"}
                                                    onChange={activeOnChange}
                                                    checked={activeValue}
                                                    disabled={disabled == true ? disabled : CheckAdmin}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={3}>
                                                <Label
                                                    htmlFor="example-text-input"
                                                    className={`col-md-12 col-form-label-sm`}
                                                >
                                                    Skip Manager Sign Off
                                                </Label>
                                            </Col>
                                            <Col >
                                                <DPSwitch
                                                    rowClass={"mb-4-sm"}
                                                    onChange={signoffOnChange}
                                                    checked={signoffValue}
                                                    disabled={disabled == true ? disabled : CheckAdmin}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={3}>
                                                <Label
                                                    htmlFor="example-text-input"
                                                    className={`col-md-12 col-form-label-sm`}
                                                >
                                                    App User
                                                </Label>
                                            </Col>
                                            <Col >
                                                <DPSwitch
                                                    rowClass={"mb-4-sm"}
                                                    onChange={appUserOnChange}
                                                    checked={appUserValue}
                                                    disabled={disabled == true ? disabled : CheckAdmin}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Row>
                                        <Col md={3}>
                                            <Label
                                                htmlFor="example-text-input"
                                                className={`col-md-12 col-form-label-sm`}
                                            >
                                                Signup With
                                            </Label>
                                        </Col>
                                        <Col md={9}>
                                            <Row>
                                                <Col md={2}>
                                                    <Link
                                                        style={{ opacity: disabled == true ? "0.5" : "1" }}
                                                        to="#"
                                                        className="social-list-item bg-danger text-white border-danger"
                                                        onClick={e => {
                                                            if (disabled == false) {
                                                                if (AddNew == true) {
                                                                    singleSignON(googleProvider)
                                                                } else if (AddNew == false && CheckUser == true) {
                                                                    singleSignON(googleProvider)
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <i className="mdi mdi-google" />
                                                    </Link>
                                                </Col>
                                                <Col md={2}>
                                                    <Link
                                                        style={{ opacity: disabled == true ? "0.5" : "1" }}
                                                        to="#"
                                                        className="social-list-item bg-primary text-white border-primary"
                                                        onClick={e => {
                                                            if (disabled != true) {
                                                                if (AddNew == true) {
                                                                    singleSignON(facebookProvider)
                                                                } else if (AddNew == false && CheckUser == true) {
                                                                    singleSignON(facebookProvider)
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <i className="mdi mdi-facebook" />
                                                    </Link>
                                                </Col>
                                                <Col md={2}>
                                                    <li className="list-inline-item">
                                                        <Link
                                                            style={{ opacity: disabled == true ? "0.5" : "1" }}
                                                            to="#"
                                                            className="social-list-item bg-success text-white border-success"
                                                            onClick={e => {
                                                                if (disabled != true) {
                                                                    if (AddNew == true) {
                                                                        singleSignON(msProvider)
                                                                    } else if (AddNew == false && CheckUser == true) {
                                                                        singleSignON(msProvider)
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <i className="mdi mdi-microsoft" />
                                                        </Link>
                                                    </li>
                                                </Col>
                                                <Col md={2}>
                                                    <li className="list-inline-item">
                                                        <Link
                                                            to="#"
                                                            className="social-list-item text-white"
                                                            onClick={e => {
                                                                if (disabled != true) {
                                                                    if (AddNew == true) {
                                                                        singleSignON(appleProvider)
                                                                    } else if (AddNew == false && CheckUser == true) {
                                                                        singleSignON(appleProvider)
                                                                    }
                                                                }
                                                            }}
                                                            style={{ opacity: disabled == true ? "0.5" : "1", backgroundColor: 'black', borderColor: 'black' }}
                                                        >
                                                            <i className="mdi mdi-apple" />
                                                        </Link>
                                                    </li>
                                                </Col>
                                                <Col md={2}>
                                                    <li className="list-inline-item">
                                                        <Link
                                                            to="#"
                                                            className="social-list-item text-white"
                                                            onClick={e => {
                                                                if (disabled != true) {
                                                                    if (AddNew == true) {
                                                                        singleSignON(yahooProvider)
                                                                    } else if (AddNew == false && CheckUser == true) {
                                                                        singleSignON(yahooProvider)
                                                                    }
                                                                }
                                                            }}
                                                            style={{ opacity: disabled == true ? "0.5" : "1", backgroundColor: '#6001d2', borderColor: '#6001d2' }}
                                                        >
                                                            <i className="mdi mdi-yahoo" />
                                                        </Link>
                                                    </li>
                                                </Col>
                                                <Col md={2}>
                                                    <li className="list-inline-item">
                                                        <Link
                                                            to="#"
                                                            className="social-list-item text-white"
                                                            onClick={e => {
                                                                if (disabled != true) {
                                                                    if (AddNew == true) {
                                                                        singleSignON(twitterProvider)
                                                                    } else if (AddNew == false && CheckUser == true) {
                                                                        singleSignON(twitterProvider)
                                                                    }
                                                                }
                                                            }}
                                                            style={{ opacity: disabled == true ? "0.5" : "1", backgroundColor: '#1DA1F2', borderColor: '#1DA1F2' }}
                                                        >
                                                            <i className="mdi mdi-twitter" />
                                                        </Link>
                                                    </li>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row> */}
                                </Col>

                                <DPSearchBoxDynamic
                                    searchData={[]}
                                    columns={HeadColumns}
                                    defaultSorted={defaultSorted}
                                    mainTitle={menuName + " Search"}
                                    SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                    isOpen={modelOpen}
                                    toggle={modelTrigger}
                                    getSelect={GetSelectRow}
                                    APIURL={ApiURL}
                                    URLPath={"USER"}
                                    MenuCode={menuCode}
                                    KeyVal={"USE"}
                                    searchBy={"UH_ID"}
                                    FilterStr={groupFilter}
                                />

                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )

}

export default UserMasterTab1